var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2673 15.8672H16.53L16.2687 15.6152C17.3887 14.3086 17.9673 12.5259 17.65 10.6312C17.2113 8.03658 15.046 5.96458 12.4327 5.64725C8.48468 5.16192 5.16201 8.48458 5.64735 12.4326C5.96468 15.0459 8.03668 17.2112 10.6313 17.6499C12.526 17.9672 14.3087 17.3886 15.6153 16.2686L15.8673 16.5299V17.2672L19.834 21.2339C20.2167 21.6166 20.842 21.6166 21.2247 21.2339C21.6073 20.8512 21.6073 20.2259 21.2247 19.8432L17.2673 15.8672ZM11.6673 15.8672C9.34335 15.8672 7.46735 13.9912 7.46735 11.6672C7.46735 9.34325 9.34335 7.46725 11.6673 7.46725C13.9913 7.46725 15.8673 9.34325 15.8673 11.6672C15.8673 13.9912 13.9913 15.8672 11.6673 15.8672Z",
    fill: "#19191D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch3);
export default __webpack_public_path__ + "static/media/search3.764221d331ee0be7937856bb3ede1887.svg";
export { ForwardRef as ReactComponent };